import { render, staticRenderFns } from "./CardOrderService.vue?vue&type=template&id=5ad7f9b2&scoped=true&"
import script from "./CardOrderService.vue?vue&type=script&lang=js&"
export * from "./CardOrderService.vue?vue&type=script&lang=js&"
import style0 from "./CardOrderService.vue?vue&type=style&index=0&id=5ad7f9b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad7f9b2",
  null
  
)

export default component.exports